var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcIne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 25,
    viewBox: "0 0 31 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.15 11.15C12.7516 11.15 14.05 9.8516 14.05 8.24998C14.05 6.64835 12.7516 5.34998 11.15 5.34998C9.54837 5.34998 8.25 6.64835 8.25 8.24998C8.25 9.8516 9.54837 11.15 11.15 11.15Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9501 16.95C16.9501 18.5522 16.9501 19.85 11.1501 19.85C5.3501 19.85 5.3501 18.5522 5.3501 16.95C5.3501 15.3477 7.9456 14.05 11.1501 14.05C14.3546 14.05 16.9501 15.3477 16.9501 16.95Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12.6C1 7.13205 1 4.39735 2.6994 2.6994C4.39735 1 7.13205 1 12.6 1H18.4C23.868 1 26.6026 1 28.3006 2.6994C30 4.39735 30 7.13205 30 12.6C30 18.068 30 20.8026 28.3006 22.5006C26.6026 24.2 23.868 24.2 18.4 24.2H12.6C7.13205 24.2 4.39735 24.2 2.6994 22.5006C1 20.8026 1 18.068 1 12.6Z",
    stroke: "#F8F8F8",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6499 12.6H19.8499M25.6499 8.25H18.3999M25.6499 16.95H21.2999",
    stroke: "#F8F8F8",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcIne);
export default __webpack_public_path__ + "static/media/icINE.07254e016cf69b95f9db1532e9c0b5d3.svg";
export { ForwardRef as ReactComponent };